import React from 'react';
import PropTypes from 'prop-types';
import { Row, Col, Checkbox } from 'antd';
import { Link } from 'react-router-dom';
import map from 'lodash/map';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

const Wrapper = styled.div`
  &&& {
    .ant-checkbox-checked {
      .ant-checkbox-inner {
        background: #9f9f9f;
        border: none;
      }
    }
    .ant-checkbox-inner {
      border-radius: 4px;
    }
    .ant-checkbox-inner {
      border-color: #c8c8c8;
      background: rgba(196, 196, 196, 0.2);
    }
  }
`;

function Rights({ data }) {
  console.log(data);
  const { t } = useTranslation();
  return (
    <Wrapper>
      <Row className="mt-10" type="flex" align="middle">
        <Col className="text-20 font-semibold text-black" span={8}>
          {t('rights')}
        </Col>
        <Col
          className="uppercase text-12 text-center pl-10 pr-10  text-graytext"
          span={3}
        >
          {t('viewBoxes')}
        </Col>
        <Col className="uppercase text-12 text-center text-graytext" span={3}>
          {t('boxManagement')}
        </Col>
        <Col className="uppercase text-12 text-center text-graytext" span={3}>
          {t('openRented')}
        </Col>
        <Col className="uppercase text-12 text-center text-graytext" span={3}>
          {t('CustomerManagement')}
        </Col>
        <Col className="uppercase text-12 text-center text-graytext" span={3}>
          {t('CustomerManagement')}
        </Col>
      </Row>
      {map(data, (item) => {
        return (
          <Row
            className="mt-10 bg-white pt-17 pb-15 rounded-small"
            type="flex"
            align="middle"
          >
            <Col className="text-14 font-semibold text-black pl-30" span={8}>
              <span className="border-b-1 border-dotted ">
                <Link to={`storages/${item.warehouse.id}`}>
                  {' '}
                  {item.warehouse.name}{' '}
                </Link>
              </span>
            </Col>
            {item.permissions[0] === 'full_access' && (
              <>
                <Col
                  className="uppercase text-12 text-center pl-10 pr-10 "
                  span={3}
                >
                  <Checkbox defaultChecked={true} />
                </Col>
                <Col className="uppercase text-12 text-center" span={3}>
                  <Checkbox defaultChecked={true} />
                </Col>
                <Col className="uppercase text-12 text-center" span={3}>
                  <Checkbox defaultChecked={true} />
                </Col>
                <Col className="uppercase text-12 text-center" span={3}>
                  <Checkbox defaultChecked={true} />
                </Col>
                <Col className="uppercase text-12 text-center" span={3}>
                  <Checkbox defaultChecked={true} />
                </Col>
              </>
            )}
          </Row>
        );
      })}
    </Wrapper>
  );
}

Rights.propTypes = {};

export default Rights;
